class ResearchAssistantService {

   configService: any
   authConfig: any
   authFeature: any
   authenticationService: any
   cloudStorageService: any
   cloudStorageProviders: any
   configProviders: any
   isResearchAssistantEnabled: boolean

   constructor(configService: ConfigService, authenticationService: AuthenticationService, cloudStorageService: CloudStorageService) {
      this.configService = configService
      this.authenticationService = authenticationService
      this.cloudStorageService = cloudStorageService
      this.authConfig = this.configService.data.authentication
      this.registerProviders = this.registerProviders.bind(this)
      this.cloudStorageProviders = this.cloudStorageService.getProviders()
      this.configProviders = this.configService.data.savedSearchAndItems.providers // Authentication by 'Microsoft'/'Google'/'Summon'
      this.isResearchAssistantEnabled = this.configService.data.researchAssistant.enabled && (this.authenticationService.isAuthenticationEnabled  || this.authenticationService.isVpnAuthenticated)
      this.authFeature = this.authenticationService.registerFeature('research_assistant', "RESEARCH_ASSISTANT_FEATURE")
      this.authFeature.showInLoginMenu = false
      if (_.includes(['CAS', 'Both'], this.authConfig.sierraAuthProtocol)) { this.authFeature.setProvider('cas',{}) }
      if (_.includes(['SAML', 'Both'], this.authConfig.sierraAuthProtocol)) { this.authFeature.setProvider('saml',{}) }

      this.registerProviders()
   }
   
   registerProviders() {
      for (var provider of this.cloudStorageProviders) {
         if (_.contains(this.configProviders, provider.name)) {
            const providerName = provider.name === 'summon' ? 'saml' : provider.name // replace summon for saml as saml to avoid issues with modal signin
            this.authFeature.setProvider(providerName, provider.loginParams)
         }
         provider.service.init()
      }
   }
   
  sendRAStatActions(eventActionDetails: { action: any; category: any; label: any; userId: string; clientKey: string}) {
    const statActionTemplate = RAActions.find(statAction => 
      (statAction.action ?? []).includes(eventActionDetails.action ?? '') &&
      (statAction.category ?? '') === (eventActionDetails.category ?? '') &&
      (!(statAction.label ?? '') || (statAction.label ?? '') === (eventActionDetails.label ?? ''))
    )

    if (statActionTemplate) {
      const statAction = {
      category: statActionTemplate.category,
      operation: statActionTemplate.operation,
      label: statActionTemplate.label || '',      
      userId: eventActionDetails.userId,
      clientKey: eventActionDetails.clientKey
      }
      
      const queryParams = new URLSearchParams({
        category: statAction.category,
        operation: statAction.operation,
        label: statAction.label,        
        userId: statAction.userId,
        clientKey: statAction.clientKey
      }).toString()

      fetch(`/research-assistant/stats?${queryParams}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(statAction)
      }).then(res => {
        if (!res.ok) {
          console.error('Failed to send research assistant stats:', res.statusText);
        }
      }).catch(err => {
        console.error('Error sending research assistant stats:', err);
      })
    }
  }
}

const RAActions = [
  {
    "action": ["search","inputbox_new", "inputbox_followup", "webcomponent", "landing","load"],
    "category": "search",
    "operation": "search",
    // "User runs a RA Search"
  },
  {
    "action": ["load"],
    "category": "session",
    "operation": "search",
    // "User runs a RA Search from research history"
  },
  {
    "action": ["regenerate"],
    "category": "answer",
    "operation": "rerunSearch",
    // "User reruns a RA Search using button rerun Search"
  },
  {
    "action": ["copy"],
    "category": "answer",
    "operation": "copyAnswer",
    // "User clicks the Copy option for RA answer"
  },
  {
    "action": ["thumbs_up"],
    "category": "feedback",
    "label": "answerId",
    "operation": "thumbsUpAnswer",
    // "User clicks the thumbs up option for RA answer"
  },
  {
    "action": ["thumbs_down"],
    "category": "feedback",
    "label": "answerId",
    "operation": "thumbsDownAnswer",
    // "User clicks the thumbs down option for RA answer"
  },
  {
    "action": ["expand-from-sourcecard"],
    "category": "source",
    "operation": "displaySource",
    // "User clicks to display source in RA answer"
  },
  {
    "action": ["quickLookLink"],
    "category": "source",
    "operation": "openQuickLook",
    // "User clicks link in Quicklook from RA source"
  },
  {
    "action": ["pdf"],
    "category": "source",
    "operation": "quicklinkPDF",
    // "User clicks PDF Quicklink in RA source"
  },
  {
    "action": ["fulltext"],
    "category": "source",
    "operation": "quicklinkHTML",
    // "User clicks HTML Quicklink in RA source"
  },
  {
    "action": ["deeplink"],
    "category": "source",
    "operation": "openfull",
    // "User opens full record display for Source in RA answer"
  },
  {
    "action": ["search-library"],
    "category": "source",
    "operation": "viewRelatedResearchInLibrary",
    // "User clicks view related research in library for Source in RA answer"
  },
  {
    "action": ["more-questions"],
    "category": "search",
    "operation": "clickRelatedResearchQuestion",
    // "User clicks related research question in RA answer"
  },
  {
    "action": ["thumbs_up"],
    "category": "feedback",
    "label": "sourceId",
    "operation": "thumbsUpSource",
    // "User clicks the thumbs up option for Source in RA source"
  },
  {
    "action": ["thumbs_down"],
    "category": "feedback",
    "label": "sourceId",
    "operation": "thumbsDownSource",
    // "User clicks the thumbs down option for Source in RA source"
  },
  {
    "action": ["help"],
    "category": "navigation",
    "operation": "clickHelp",
    // "User clicks the Help function"
  },
  {
    "action": ["disclaimer"],
    "category": "navigation",
    "operation": "clickAIDisclaimer"
    // "User clicks the AI disclaimer"
  },
  {
    "action": ["new-session"],
    "category": "navigation",
    "operation": "newSession"
    // "User clicks the AI new session"
  }
]

ResearchAssistantService.$inject = ['configService', 'authenticationService','cloudStorageService']

angular.module('summonApp.services')
   .service('researchAssistantService', ResearchAssistantService)
